define('uikit/modules/input.time',['require','exports','module','underscore','backbone','marionette','moment','../channel','../mixins/component.mixin','../elements/dropdown'],function(require, exports, module){
  var _ = require('underscore');
  var Backbone = require('backbone');
  var Mn = require('marionette');
  var moment = require('moment');
  var channel = require('../channel');
  var ComponentMixin = require('../mixins/component.mixin');
  var Dropdown = require('../elements/dropdown');


  function timeSort(model) {
    return model.get('date');
  };

  var TimeInput = Mn.ItemView.extend(ComponentMixin).extend({

    options: {
      // time interval
      disabled    : false,
      interval    : 15,
      icon        : 'time',
      placeholder : 'HH:MM',
      format      : 'LT',
      value       : null
    },

    forceUpdate: { disabled: true },

    template: function() {
      return '<ui name="dropdown" />';
    },

    initialize: function() {
      ComponentMixin.initialize.apply(this, arguments);

      this.dropdown = new Dropdown({ 
        disabled: this.disabled,
        icon: this.icon, 
        placeholder: this.placeholder, 
        search: true, 
        iconRight: false, 
        fluid: true ,
      });

      this.dropdown.collection = new Backbone.Collection([], { comparator: timeSort });
      
      this.customModel         = null;
      this.dropdown.childBindings.text = 'text';
      this._setupCollection();
    },

    createModelFromString: function(timeString) {
      // we have to explicitly use slash delimited
      // date format because firefox does not understand
      // anything else...silly firefox...what a cluster fuck
      var dateString = moment().format('MM/DD/YYYY') + ' ' + timeString

      var date = moment(new Date(dateString));
      if (date.isValid()) {
        return this.createModelFromDate(date);
      }
    },

    createModelFromDate: function(date) {
      return new Backbone.Model({
        date: +date,
        text: date.format(this.format)
      });
    },

    addCustomModel: function(model) {
      var dropdown = this.dropdown;
      dropdown.collection.remove(this.customModel);
      dropdown.collection.add(model);
      this.customModel = model;
    },

    onDropdownChangeValue: function() {
      var model = this.dropdown.value;
      // whenever we pick a non-custom value
      // then we want to remove the custom model from
      // the collection
      if (this.customModel !== model) {
        this.dropdown.collection.remove(this.customModel);
        this.customModel = null;
      }
      this.value = model ? model.get('date') : null;
    },

    onDropdownItemAdd: function(view, value, ev) {
      var model     = this.createModelFromString(value),
          dropdown  = this.dropdown,
          className = $.fn.dropdown.settings.className,
          module    = dropdown.$el.data().moduleDropdown,
          $choice   = null

      if (model) {
        this.addCustomModel(model);
        $choice = dropdown.findItemByModel(model);
      } else {
        $choice = dropdown.findItemByModel(dropdown.value);
      }

      if ($choice.length > 0) {
        // this guarantees that this item will be selected no matter what
        $choice.addClass(className.selected).removeClass(className.active);
        _.defer(function() {
          module.event.item.click.call($choice, ev);
        })
      }
    },

    onChangeValue: function() {
      if (this.value) {
        this._hadValuePreviously = true;
      }
      this._syncValueToDropdown();
    },

    onChangeDisabled: function() {
      this.dropdown.disabled = this.disabled;
    },

    onChangeInterval: function() {
      this._setupCollection();
    },

    onChangeFormat: function() {
      this._setupCollection();
    },

    findModelByDate: function(date) {
      return this.dropdown.collection.find(function(m) {
        var mDate = moment(m.get('date'));
        return mDate.hour() == date.hour() && mDate.minute() == date.minute();
      });
    },

    _syncValueToDropdown: function() {
      var value = this.value,
          date,
          model,
          self = this;

      if (!value) {
        this.dropdown.value = null;
        return;
      }

      date = moment(value);

      if (!date.isValid()) {
        this.dropdown.value = null;
        return;
      }

      model = this.findModelByDate(date);

      if (model) {
        this.dropdown.value = model;
      } else {
        model = this.createModelFromDate(date);
        this.addCustomModel(model);
        this.dropdown.value = model;
      }
    },

    _setupCollection: function() {
      var m       = moment(new Date()).startOf('day'),
          today   = moment(new Date()),
          minutes = [];

      while (m.isSame(today, 'day')) {
        minutes.push(this.createModelFromDate(m));
        m.add(this.interval, 'minutes');
      }

      this.dropdown.collection.reset(minutes);
      this._syncValueToDropdown();
    }

  });

  channel.reply('input-time', function() {
    return TimeInput;
  });

  module.exports = TimeInput;
});
